import css from '../../../utils/css';

export default css`
  div[class*='QuickBetTooltipDisclosure'] {
    display: none;
  }

  .tsqd-parent-container {
    width: 50px;
    height: 50px;
    position: fixed;
    right: 5px;
    bottom: 5px;
  }

  /* fix for 6.0.1 flickering header */
  [class*='AccordionHeader'] {
    border: 1px solid var(--ogm-grid-main-border-color);
  }

  /* inherit same styles for Exchange label from Bookmakers label */
  [class*='BookmakersLabel_'] [class*='InfoLabel'] {
    font-family: inherit;
    font-size: inherit;
    font-weight: inherit;
    text-transform: inherit;
  }

  /* make text on offers hoverables visible */
  [data-testid='signup-offer'] [class*='roundedCell_'] > span {
    z-index: 1;
    position: relative;
  }

  /* module should not have margins */
  [class*='GridBackground'] {
    margin-bottom: 0 !important;
  }

  [class*='BetBestOddsButtonWrapper'] button {
    line-height: inherit;
  }

  /* change width of odds clickables on mobile */
  [class*='OddsRow'] [class*='OddsCellMobile'] {
    min-height: 0;
    width: var(--widget-grid-cell-mobile-width, 60px);
  }

  /* fix toggler's pointer position */
  button[class*='GridToggler'][aria-expanded='true'] > span[class^='Pointer_'] {
    top: calc(100% - 5px);
  }

  /* fix toggler's arrow colour */
  button[class*='GridToggler']:after {
    border-color: currentColor;
  }

  /* hide legends from desktop view, is causing alignment issue when legend is translated */
  [class*='OffersSection'] {
    display: block;
    margin-top: 58px;
  }

  [class*='OffersSection']:has([class*='OffersLabel']) {
    margin-top: 38px;
  }

  [class*='OffersSection'] [class*='OffersLabel'] {
    text-align: right;
    padding-right: 20px;
  }
  [class*='OffersSection'] [class*='OffersLegendColumn'] {
    display: none;
  }

  [class*='OffersLegendItem'] [class*='OddsInfoItem'] {
    visibility: hidden;
  }

  /* fixing artifacts from above patch */
  [class*='QuickBetTitleWrapper'] {
    height: var(--ogm-grid-bookmaker-cell-height-desktop);
  }

  [class^='defaulTooltipStyles_'] {
    background-color: #fff !important;
  }
`;
